module.exports = __webpack_public_path__ + "static/media/notification.942be27e.wav";